/**
 * watchlist-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tsmith@safetyweb.org>
 */

import { WatchlistEntry } from "../../../watchlist/watchlist-entry";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * The {@link WatchlistResponse} transmits a user's current watchlist, primarily
 * during the initial message bundle.
 */
@validateFor(MessageTag.RSP_WATCHLIST)
export class WatchlistResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_WATCHLIST;

  @validateOpaqueID()
  public objectId : number;

  @validateAs({array: "object"}) // TODO: better validation
  public worklist : WatchlistEntry[];

  public isShared? : boolean;
  public groupId? : number;

  /**
   * NOTE: When this is used as a response to a {@link SharedWorklistRequest}
   * it will have additional fields, however instead of annotating them here,
   * we simply assert the message is the intersection of this class and the
   * {@link SharedList} interface.
   */
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/watchlist-response.ts